import { postCall, getCall, putCall } from "./api";
import {
  getLegalUnitList,
  getActiveLegalUnit,
  setActiveLegalUnit,
  invalidateGeofences,
} from "./globalData";

const invalidating = (res) => {
  if (res?.success !== false) invalidateGeofences();
  return res;
};

// resolve the active legal unit id (falling back to the first available)
const resolveLegalUnitId = () => {
  const active = getActiveLegalUnit();
  if (active) return active._id;
  const all = getLegalUnitList();
  if (all.length > 0) {
    setActiveLegalUnit(all[0]);
    return all[0]._id;
  }
  return null;
};

export const addGeofence = async (input = {}) => {
  const legalUnitId = resolveLegalUnitId();
  if (!legalUnitId) return;
  return invalidating(await postCall({ path: `/legal-unit-geofence/${legalUnitId}/geofence/`, bodyParams: input }));
};

export const updateGeofence = async (input = {}) => {
  const legalUnitId = resolveLegalUnitId();
  if (!legalUnitId) return;
  return invalidating(await putCall({ path: `/legal-unit-geofence/${legalUnitId}/geofence/`, bodyParams: input }));
};

// create or update — geofence is one-per-legal-unit, so POST fails if one exists
export const upsertGeofence = async (input = {}) => {
  const existing = await getGeofence();
  const hasFence = Array.isArray(existing?.data) && existing.data.length > 0;
  return hasFence ? await updateGeofence(input) : await addGeofence(input);
};

export const getGeofence = async () => {
  const legalUnitId = resolveLegalUnitId();
  if (!legalUnitId) return;
  return await getCall({ path: `/legal-unit-geofence/${legalUnitId}/geofence/` });
};

export const addGeofenceToLegalUnit = async (legalUnitId, geofence) => {
  return invalidating(await postCall({ path: `/legal-unit-geofence/${legalUnitId}/geofence/`, bodyParams: geofence, }));
};